<template>
  <div class="industry-finance-collaboration">
    <div class="banner">
      <img src="../../../assets/img/businessScope/industryFinanceCollaboration/banner.jpg" />
      <div class="banner-text">
        <div class="container wow slideInLeft">
          <h1>{{$t("industryFinanceCollaboration.banner.bannerTitle")}}</h1>
          <p>{{$t("industryFinanceCollaboration.banner.bannerP")}}</p>
        </div>
      </div>
    </div>

    <div class="global-layout container">
      <div class="headline">
        <h1>{{$t("industryFinanceCollaboration.globalLayout.headlineTitle")}}</h1>
        <p>{{$t("industryFinanceCollaboration.globalLayout.headlineP")}}</p>
      </div>
      <p class="des">{{$t("industryFinanceCollaboration.globalLayout.des")}}</p>
      <img :src="$t('industryFinanceCollaboration.globalLayout.map')" />
    </div>

    <div class="generation-mining-and-generation-pin hidden-xs-only">
      <div class="headline">
        <h1>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.headlineTitle")}}</h1>
        <p>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.headlineP")}}</p>
      </div>
      <div class="enterprise-advantage-wrap">
        <el-row>
            <el-col :span="8">
              <div class="enterprise-advantage">
                <p>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.enterpriseAdvantage.titleEn")}}</p>
                <h2>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.enterpriseAdvantage.title")}}</h2>
                <div v-html="$t('industryFinanceCollaboration.generationMiningAndGenerationPin.enterpriseAdvantage.des')"></div>
                <router-link to="/contact"><el-button type="primary" plain>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.enterpriseAdvantage.btn")}}</el-button></router-link>
              </div>
            </el-col>
            <el-col :span="16" class="span16">
              <div class="pic-wrap" v-for="(item,index) in $t('industryFinanceCollaboration.generationMiningAndGenerationPin.lists')" :key="index">
                <img :src="item.pic" class="pic"/>
                <div class="des-box">
                  <img :src="item.circlePic" class="circlePic"/>
                  <img :src="item.icon" alt="" class="icon">
                  <h3 :class="language=='cn'?'':'vertical'">{{item.title}}</h3>
                  <p>{{$t("industryFinanceCollaboration.generationMiningAndGenerationPin.enterpriseAdvantage.btn")}}</p>
                </div>
              </div>
            </el-col>
        </el-row>
      </div>
    </div>

    <div class="protection-and-factoring container">
      <div class="headline">
        <h1>{{$t("industryFinanceCollaboration.protectionAndFactoring.headlineTitle")}}</h1>
        <p>{{$t("industryFinanceCollaboration.protectionAndFactoring.headlineP")}}</p>
      </div>
      <el-row :gutter="60">
        <el-col :span="14" :xs="24">
          <div class="des">
            <p>{{$t('industryFinanceCollaboration.protectionAndFactoring.des1')}}</p>
            <p>{{$t('industryFinanceCollaboration.protectionAndFactoring.des2')}}</p>
            <p class="tr">____</p>
          </div>
        </el-col>
        <el-col :span="10" :xs="24" class="pic">
            <img src="../../../assets/img/businessScope/industryFinanceCollaboration/zhengshu.png" />
        </el-col>
      </el-row>
    </div>

    <div class="industrial-investment container">
      <div class="headline">
        <h1>{{$t("industryFinanceCollaboration.industrialInvestment.headlineTitle")}}</h1>
        <p>{{$t("industryFinanceCollaboration.industrialInvestment.headlineP")}}</p>
      </div>
      <p class="des">{{$t("industryFinanceCollaboration.industrialInvestment.des")}}</p>
      <el-row :gutter="60">
          <el-col :span="12" :xs="24" v-for="(item,index) in $t('industryFinanceCollaboration.industrialInvestment.lists')" :key="index">
            <div class="pic-wrap">
              <div class="des-box">
                  <div class="des-icon"><img :src="item.icon" /></div>
                  <h2>{{item.title}}</h2>
                  <p>{{item.des}}</p>
              </div>
              <img :src="item.pic" class="pic"/>
            </div>
          </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IndustryFinanceCollaboration",
  data() {
    return {

    };
  },
  mounted() {
    var options = { live: false };
    new this.$wow.WOW(options).init();
  },
  computed:{
    ...mapGetters(['language'])
  },
  methods: {

  }
};
</script>

<style scoped lang="scss">
.industry-finance-collaboration {
  .global-layout{
    .des{
      width:50%;
      margin:0 auto;
      margin-bottom:60px;
      text-align: justify;
    }
  }
  .generation-mining-and-generation-pin{ 
    .enterprise-advantage-wrap{
      color:#fff;
      background:#22272B;
      .enterprise-advantage{
        width:200px;
        margin:0 auto;
        padding-top:80px;
        h2{
          font-weight: bold;
          margin-bottom:40px;
        }
        .el-button{
          // background:transparent;
          // color:#fff;
          margin-top:100px;
        }
      }
      
      .span16{
        display: flex;
        .pic-wrap{
          position: relative;
          flex-shrink: 1; 
          transition: all 0.4s;
          .pic{
            object-fit: cover;
            height:600px;
            opacity: 0.5;
            width:300px;
          }
          .des-box{
            position: absolute;
            left:0;
            top:0;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            padding-top:80px;
            box-sizing: border-box;
            .vertical{
              transform: rotate(-90deg);
              position: relative;
              top:50px;
            }
            .circlePic{
              display: none;
              margin-bottom:40px;
            }
            h3{
              margin-top:20px;
            }
            p{
              display: none;
              margin-top:30px;
            }
          }
          &:hover {
            flex-shrink: 0; 
            .des-box{
              background:#22272B;
              .circlePic{
                display: block;
              }
              h3{
                display: none;
              }
              p{
                display: block;
              }
              .icon{
                transform: scale(1.5);
              }
            }
          }
        }
      }
    }
  }
  .protection-and-factoring{
    .des{
      background:#0054A7;
      color:#fff;
      padding:40px 60px;
      border-radius: 10px;
      p{
        text-align: justify;
      }
      p+p{
        margin-top:40px;
      }
      .tr{
        text-align: right;
        font-weight: bold;
      }
    }
    .pic{
      text-align: center;
      img{
        width:70%;
      }
    }
  }
  .industrial-investment{
    .des{
      width:70%;
      margin:0 auto;
      margin-bottom:100px;
    }
    .pic-wrap{
      position: relative;
      margin-bottom:60px;
      overflow: hidden;
      img.pic{
        width:100%;
      }
      .des-box{
        position: absolute;
        left:0px;
        top:100%;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        background:rgba(0,0,0,0.42);
        color:#fff;
        padding:30px;
        box-sizing: border-box;
        transition: all 0.4s;
        .des-icon{
          text-align: center;
        }
        h2{
          text-align: center;
          margin:10px 0 ;
        }
        p{
          text-align: justify;
          line-height: 1.5;
        }
      }
      &:hover{
        .des-box{
          top:0;
        }
      }
    }
  }
  @media screen and (max-width:768px){
    .global-layout{
      .des{
        width:100%;
        margin:0 auto;
        margin-bottom:40px;
        text-align: justify;
      }
    }
    .protection-and-factoring{
      .des{
        background:#0054A7;
        color:#fff;
        padding:20px;
        border-radius: 10px;
        p{
          text-align: justify;
        }
        p+p{
          margin-top:20px;
        }
        .tr{
          text-align: right;
          font-weight: bold;
        }
      }
      .pic{
        text-align: center;
        img{
          width:100%;
        }
      }
    }
    .industrial-investment{
      .des{
        width:100%;
        margin:0 auto;
        margin-bottom:40px;
      }
      .pic-wrap{
        position: relative;
        margin-bottom:40px;
        overflow: hidden;
        img.pic{
          width:100%;
        }
        .des-box{
          position: relative;
          left:0px;
          top:0px;
          width: 100%;
          height: auto;
          border-radius: 10px;
          background:#0054A7;
          color:#fff;
          padding:15px;
          box-sizing: border-box;
          transition: all 0.4s;
          margin-bottom:20px;
          .des-icon{
            img{
              width:50px;
            }
          }
          h2{
            text-align: center;
            margin:10px 0 ;
            font-size: 18px;
          }
          p{
            text-align: justify;
            line-height: 1.5;
            font-size: 14px;
          }
        }
        &:hover{
          .des-box{
            top:0;
          }
        }
      }
    }
  }
}
</style>
